import { NavBar } from "../navBar/NavBar";

import type { ReactNode } from "react";
import type { AlignProp } from "../components";

export interface QuizViewHeaderGroupProps {
  align?: AlignProp;
  children?: ReactNode;
}

export function QuizViewHeaderGroup({
  align,
  children,
}: QuizViewHeaderGroupProps) {
  return <NavBar.Group align={align}>{children}</NavBar.Group>;
}
